var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowFill2Red(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48.00 48.00",
    "data-guides": "{\"vertical\":[],\"horizontal\":[]}",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ff0000",
    stroke: "#ff0000",
    fillOpacity: 1,
    strokeWidth: 2,
    strokeOpacity: 1,
    alignmentBaseline: "baseline",
    baselineShift: "baseline",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "cls-1",
    id: "tSvg27f5a424ca",
    title: "Path 1",
    d: "M6.8602 23.9997C9.9068 23.9997 12.9535 23.9997 16.0002 23.9997C16.0002 16.3331 16.0002 8.6664 16.0002 0.9997C21.3335 0.9997 26.6668 0.9997 32.0002 0.9997C32.0002 8.6664 32.0002 16.3331 32.0002 23.9997C35.0468 23.9997 38.0935 23.9997 41.1402 23.9997C35.4268 31.6664 29.7135 39.3331 24.0002 46.9997C18.2868 39.3331 12.5735 31.6664 6.8602 23.9997Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowFill2Red);
export default __webpack_public_path__ + "static/media/arrow-fill-2-red.0214c06d701c20c9103d88c63a80ad4c.svg";
export { ForwardRef as ReactComponent };